import { z } from 'zod';
/**
 * Feed-Contracts (07 – Datenmodell, ADR-005). Der Feed ist eine Aggregat-Tabelle:
 * kind = post | comment | system. Kommentare hängen per parentId an einer Aktivität.
 */
export const FEED_KINDS = ['post', 'comment', 'system', 'poll'];
export const feedCommentDtoSchema = z.object({
    id: z.string().uuid(),
    actorId: z.string().uuid().nullable(),
    body: z.string().nullable(),
    createdAt: z.string(),
});
/**
 * Abstimmungen im Feed (ADR-081). Eltern erstellen eine Abstimmung mit mehreren
 * Optionen; alle Mitglieder (auch Kinder) verteilen bis zu `votesPerMember` Stimmen
 * auf VERSCHIEDENE Optionen (je Option max. 1 Stimme). Offen: `voterIds` zeigt, wer
 * welche Option gewählt hat. Änderbar bis der Ersteller die Abstimmung schließt.
 */
export const pollOptionDtoSchema = z.object({
    id: z.string().uuid(),
    label: z.string(),
    voterIds: z.array(z.string().uuid()),
});
export const pollDtoSchema = z.object({
    id: z.string().uuid(),
    question: z.string(),
    votesPerMember: z.number().int().min(1),
    closed: z.boolean(),
    createdBy: z.string().uuid().nullable(),
    options: z.array(pollOptionDtoSchema),
    myVoteOptionIds: z.array(z.string().uuid()),
});
export const feedActivityDtoSchema = z.object({
    id: z.string().uuid(),
    kind: z.enum(FEED_KINDS),
    actorId: z.string().uuid().nullable(),
    body: z.string().nullable(),
    attachmentUrl: z.string().nullable(),
    isPinned: z.boolean(),
    refType: z.string().nullable(),
    refId: z.string().uuid().nullable(),
    createdAt: z.string(),
    likeCount: z.number().int(),
    likedByMe: z.boolean(),
    comments: z.array(feedCommentDtoSchema),
    // Nur bei kind === 'poll' gesetzt (eingebettet, damit der Feed keine N+1-Ladung braucht).
    poll: pollDtoSchema.nullable(),
});
export const feedPageSchema = z.object({
    activities: z.array(feedActivityDtoSchema),
    nextCursor: z.string().nullable(),
});
/** Nur http/https zulassen (Low): `javascript:`/`data:`-URLs im Feed sperren (XSS). */
const safeHttpUrl = z
    .string()
    .url()
    .refine((u) => /^https?:\/\//i.test(u), { message: 'Nur http(s)-Links erlaubt' });
export const createPostSchema = z.object({
    body: z.string().min(1).max(2000),
    attachmentUrl: safeHttpUrl.nullable().optional(),
});
export const createCommentSchema = z.object({
    body: z.string().min(1).max(2000),
});
/** Abstimmung anlegen (nur Eltern, ADR-081): Frage + 2..10 Optionen + Stimmen pro Person. */
export const createPollSchema = z.object({
    question: z.string().min(1).max(200),
    options: z.array(z.string().trim().min(1).max(120)).min(2).max(10),
    votesPerMember: z.number().int().min(1).max(10),
});
/** Abstimmen (ADR-081): die VOLLSTÄNDIGE Auswahl des Mitglieds (Ersetzen-Semantik);
    leeres Array = eigene Stimmen zurückziehen. Max. `votesPerMember`, je Option höchstens 1×. */
export const votePollSchema = z.object({
    optionIds: z.array(z.string().uuid()).max(10),
});
/** WebSocket-Notify-Nachricht (ADR-004): reiner Hinweis, Client lädt Delta per REST. */
export const wsMessageSchema = z.object({
    channel: z.enum(['feed', 'lists', 'calendar', 'chat', 'allowance', 'points']),
});
//# sourceMappingURL=feed.js.map